import React, { useEffect, useState } from "react";
import Template from "../../layout/Template";
import './dashboard.css'
import { DashboardService } from "../../services/api/Dashboard/DashboardService";
import { map } from "zod";
import { statusAgendamentosUtils } from "../../utils/statusAgendamentosUtils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarDays, faPaw, faUsers } from "@fortawesome/free-solid-svg-icons";
const Dashboard = () => {

    const [dadosDashboard, setDadosDashboard] = useState({
        totalClientes: 0,
        totalAnimais: 0,
        totalAgendamentosStatus: [],
        totalAgendamentos: 0
    })

    useEffect(() => {
        const fetchDashboard = async () => {
            const data = await DashboardService.getAll()
            let dadosAgendamentos = []
            let totalAgendamento = 0;
            if (data.success) {


                data.data?.totalAgendamentos?.map((item) => {

                    let statsAg = statusAgendamentosUtils().find((element) => element.id == item.status)


                    dadosAgendamentos.push({
                        nome: statsAg.nome,
                        qnt: item.total,
                        iconFa: statsAg.iconFa
                    })
                    totalAgendamento += item.total

                })

                setDadosDashboard({
                    ...dadosDashboard,
                    totalClientes: data.data?.totalClientes,
                    totalAnimais: data.data?.totalAnimais,
                    totalAgendamentosStatus: dadosAgendamentos,
                    totalAgendamentos: totalAgendamento
                })
            }


        }
        fetchDashboard()

    }, [])

    console.log(dadosDashboard)
    return (
        <>
            <Template>
                <h3 className="text-primary">Painel</h3>
                <hr></hr>
                <div className="    ">
                    <div className="row">
                        <div class="col-md-4 col-xl-3">
                            <div className="card bg-c-blue order-card">


                                <div className="card-block" style={{ display: 'flex', alignItems: "center", gap: '15px' }}>
                                    <FontAwesomeIcon icon={faUsers} size="2xl" />
                                    <div>
                                        <h5 className="m-b-20 " >Total de Clientes</h5>
                                        <h2 className="text-left"><i className="fa fa-cart-plus f-left"></i><span>{dadosDashboard.totalClientes}</span></h2>

                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className="col-md-4 col-xl-3">
                            <div className="card bg-c-blue order-card">
                                <div className="card-block">
                                    <FontAwesomeIcon icon={faPaw} size="2xl" />
                                    <div>
                                        <h5 className="m-b-20  titulo">Total de Animais</h5>
                                        <h2 className="text-left"><i className="fa fa-cart-plus f-left"></i><span>{dadosDashboard.totalAnimais}</span></h2>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="row">
                        {dadosDashboard?.totalAgendamentosStatus?.map((item) => (
                            <>

                                <div class="col-md-4 col-xl-3">
                                    <div className="card bg-c-green order-card">
                                        <div className="card-block">
                                            <FontAwesomeIcon icon={item.iconFa} size="2xl" />
                                            <div>
                                                <h5 className="m-b-20  titulo" >Total    {item.nome}</h5>
                                                <h2 className="text-left"><i className="fa fa-cart-plus f-left"></i><span>{item.qnt}</span></h2>
                                            </div>
                                        </div>
                                    </div>
                                </div>




                            </>
                        ))}
                    </div>
                </div>
            </Template >

        </>
    )
}
export default Dashboard;